var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNotGroup)?_c('div',_vm._l((_vm.items),function(item,i){return _c('span',{key:'instalacion'+i},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }